/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import Api from "../../../services/api";


export class ApiContextType {
    constructor (public api: Api) {}
}

export const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const useApiContext = (): ApiContextType => {
    const context = useContext(ApiContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the ApiContext");
    }
    return context;
};